import { useState, useEffect } from "react";
import { loadEmployeeListByDepartmentID } from "../services/employeeService";


const useEmployeeByDepartmentID = () => {
    const [employee, setEmployee] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedEmployeeID, setSelectedEmployeeID] = useState(null);
    const [isEmployeeDataLoaded, setIsEmployeeDataLoaded] = useState(false);

    // Fetch department data
    const fetchEmployee = async (selectedID = null, departmentID) => {
       
            const para = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1, p_id_department: departmentID };
            try {
                if (departmentID && departmentID !== 0) {
                    const data = await loadEmployeeListByDepartmentID(para);
                    if (data && data.length > 0) {
                        setEmployee(data);

                        const initialEmployee = data.find((dept) => dept.id_employee === selectedID) || [];
                        if (initialEmployee) {
                            setSelectedEmployee(initialEmployee);
                            setSelectedEmployeeID(initialEmployee.id_employee);
                        }

                        setIsEmployeeDataLoaded(true);
                    }
                }

            } catch (error) {
                // CallMessage("error", error.message, "Error");
            }      

    };

      

    // Function to load department based on selected ID
    const loadEmployeeByID = async (selectedID, departmentID) => {
        await fetchEmployee(selectedID, departmentID);
    };

    return {
        employee,
        selectedEmployee,
        selectedEmployeeID,
        setSelectedEmployee,
        setSelectedEmployeeID,
        loadEmployeeByID,
    };
};

export default useEmployeeByDepartmentID;



